import React from "react";
import withSession from "./withSession";
import { SuperblocksEmbed } from "@superblocksteam/embed-react";

const IndvReport = (props) => {
  return (
    <div style={{ width: "100vw", height: "100vh", margin: 0, padding: 0 }}>
      <SuperblocksEmbed
        src="https://app.superblocks.com/embed/applications/cad32ac9-71f3-4708-8abd-6ff00c045de8"
        style={{ width: "100%", height: "100%" }} // Ensure the embed takes full size
      />
    </div>
  );
};

export default withSession(IndvReport);
